import React, { useState, useEffect } from "react";
import { db } from "../firebase"; // Your Firebase config
import { ref, get, getDatabase } from "firebase/database";
import {
  FaSearch,
  FaUser,
  FaBook,
  FaListOl,
  FaChalkboardTeacher,
  FaTable,
} from "react-icons/fa"; // Import icons

// Modal Component
//  useEffect(() => {
//  
//     setLanguage(storedLanguage);
//   }, []);
  
const TestDetailsModal = ({ testDetails, testName, onClose }) => {
  const language = localStorage.getItem('language') || 'English';
  const handlePrint = () => {
    const printWindow = window.open("", "_blank");
    printWindow.document.write(`
      <html>
        <head>
          <title>Print Test Details</title>
          <style>
          @page {
            size: A4 portrait;
            margin: 0;
          }
            body {
               font-family: Arial, sans-serif;
            margin: 0;
            padding: 20px;
            background: #f9f9f9;
            width: 100%;
            height: 100%;
            box-sizing: border-box;
            }
            .print-header {
               display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 20px;
            padding: 10px;
            background: #fff;
            border-radius: 8px;
            box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
            width: 100%;
            box-sizing: border-box;
            }
            .print-header h2 {
              margin: 0;
              font-size: 24px;
              text-align: center;
              margin-left: 30%;
              color: #333;
              display: flex;
            }
            .print-header p {
             margin: 0;
            font-size: 16px;
            color: #666;
           
            margin-right: 20px;
            }
            .question {
             margin-bottom: 20px;
            padding: 15px;
            background: #fff;
            border-radius: 8px;
            box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
            width: 100%;
            box-sizing: border-box;
            }
            .question h4 {
              margin: 0 0 10px 0;
              font-size: 18px;
              color: #333;
            }
            .question p {
              margin: 5px 0;
              font-size: 16px;
              color: #555;
            }
            .question .correct-answer {
              color: green;
            }
            .question .user-answer {
              color: ${(questionData) =>
                questionData.userAnswer === questionData.correctAnswer
                  ? "green"
                  : "red"};
            }
          </style>
        </head>
        <body>
          <div class="print-header">
          <h2 style="text-align: center">Test:- ${testName}</h2>
          <div>
            <p>Name: ${testDetails.studentName || "-"}</p>
            <p>Roll No: ${testDetails.rollNo || "-"}</p>         
            <p>Total Marks: ${testDetails.totalMarks || "-"}</p>
            <p>Score: ${testDetails.score || "- "}</p>
          </div>
        </div>
          <ol>
            ${Object.entries(testDetails.questions || {})
              .map(
                ([questionKey, questionData], index) => `
              <li class="question">
                <h4>Q${index + 1}. ${
                  questionData.questionText || "No question available"
                }</h4>
                <div>
                  <p class="correct-answer"><strong>Correct Answer:</strong> ${
                    questionData.correctAnswer || "Not available"
                  } ✔️</p>
                  <p class="user-answer"><strong>Student's Answer:</strong> ${
                    questionData.userAnswer || "Not answered"
                  } ${
                  questionData.userAnswer === questionData.correctAnswer
                    ? "✔️"
                    : "❌"
                }</p>
                </div>
              </li>
             `
              )
              .join("")}
          </ol>
        </body>
      </html>
    `);
    printWindow.document.close();
    printWindow.print();
    printWindow.close();
  };

  return (
      <div>
        <h3
          style={{
            marginBottom: "20px",
            fontWeight: "600",
            color: "#333",
            display: "flex",
            alignItems: "center",
            gap: "10px",
          }}
        >
         {language==="English"? "Test": 'चाचणी'} :- {testName}
        </h3>
        {Object.entries(testDetails.questions || {}).map(
          ([questionKey, questionData], index) => {
            const isCorrect =
              questionData.userAnswer === questionData.correctAnswer;
            return (
              <div
                key={questionKey}
                style={{
                  backgroundColor: "#f9f9f9",
                  padding: "10px",
                  borderRadius: "6px",
                  border: "1px solid #ddd",
                  marginBottom: "10px",
                }}
              >
                <p style={{ fontWeight: "600", color: "#333", fontSize:'16px' }}>
                  Q{index + 1}.{" "}
                  {questionData.questionText || "No question available"}
                </p>
                <div style={{ marginLeft: "15px" }}>
                  <p  style={{fontSize:'16px' }}>
                    <strong>Correct Answer:</strong>{" "}
                    {questionData.correctAnswer || "Not available"}{" "}
                    <span style={{ color: "green" }}>✔️</span>
                  </p>
                  <p>
                    <strong>Student's Answer:</strong>{" "}
                    {questionData.userAnswer || "Not answered"}{" "}
                    {isCorrect ? (
                      <span style={{ color: "green" }}>✔️</span>
                    ) : (
                      <span style={{ color: "red" }}>❌</span>
                    )}
                  </p>
                </div>
              </div>
            );
          }
        )}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginTop: "20px",
          }}
        >
          <button
            onClick={handlePrint}
            style={{
              backgroundColor: "#28a745",
              color: "#fff",
              padding: "8px 12px",
              borderRadius: "6px",
              border: "none",
              cursor: "pointer",
              fontWeight: "500",
              fontSize: "14px",
              transition: "all 0.3s ease",
            }}
            onMouseOver={(e) => (e.target.style.backgroundColor = "#218838")}
            onMouseOut={(e) => (e.target.style.backgroundColor = "#28a745")}
          >
            Print
          </button>
          <button
            onClick={onClose}
            style={{
              backgroundColor: "#007BFF",
              color: "#fff",
              padding: "8px 12px",
              borderRadius: "6px",
              border: "none",
              cursor: "pointer",
              fontWeight: "500",
              fontSize: "14px",
              transition: "all 0.3s ease",
            }}
            onMouseOver={(e) => (e.target.style.backgroundColor = "#0056b3")}
            onMouseOut={(e) => (e.target.style.backgroundColor = "#007BFF")}
          >
            Close
          </button>
        </div>
      </div>
   
  );
};

const StudentResult = () => {
  const [className, setClassName] = useState("");
  const [division, setDivision] = useState("");
  const [subject, setSubject] = useState("");
  const [testName, setTestName] = useState("");
  const [results, setResults] = useState({});
  const [errorMessage, setErrorMessage] = useState("");
  const [selectedTestDetails, setSelectedTestDetails] = useState(null);
  const [subjects, setSubjects] = useState([]); // State to store subjects
  const [testNames, setTestNames] = useState([]); // State to store test names
 const language = localStorage.getItem('language') || 'English';
    const [selectedClass, setSelectedClass] = useState('');
    const [selectedDivision, setSelectedDivision] = useState(" "); 
 const [divisions, setDivisions] = useState({}); 
  const udiseNumber = localStorage.getItem("udiseNumber");
  const [classes, setClasses] = useState([]);
    const [alertMessage, setAlertMessage] = useState("");
      const [showAlert, setShowAlert] = useState(false);
        const [classOptions, setClassOptions] = useState([]);
          const [divisionOptions, setDivisionOptions] = useState([]);
   useEffect(() => {
        if (alertMessage) {
          setShowAlert(true);
          const timeoutId = setTimeout(() => {
            setShowAlert(false);
            setAlertMessage(""); 
          }, 3000);
          return () => clearTimeout(timeoutId);
        }
      }, [alertMessage]);
    
    
      const sortClasses = (classes, language) => {
        const classOrder = {
          "Class I": 1,
          "Class II": 2,
          "Class III": 3,
          "Class IV": 4,
          "Class V": 5,
          "Class VI": 6,
          "Class VII": 7,
          "Class VIII": 8,
          "Class IX": 9,
          "Class X": 10,
          "Class XI": 11,
          "Class XII": 12,
          "इयत्ता पहिली": 1,
          "इयत्ता दुसरी": 2,
          "इयत्ता तिसरी": 3,
          "इयत्ता चौथी": 4,
          "इयत्ता पाचवी": 5,
          "इयत्ता सहावी": 6,
          "इयत्ता सातवी": 7,
          "इयत्ता आठवी": 8,
          "इयत्ता नववी": 9,
          "इयत्ता दहावी": 10,
          "इयत्ता अकरावी": 11,
          "इयत्ता बारावी": 12,
        };
      
        return classes.sort((a, b) => classOrder[a] - classOrder[b]);
      };

  const handleDivisionChange = (e) => {
    setSelectedDivision(e.target.value);
  };

    const fetchClassDivData = async () => {
      try {
        const storedDivClasses = localStorage.getItem("classDiv");
        if (storedDivClasses) {
          const data = JSON.parse(storedDivClasses);
          
          const classList = [];
          const divisionList = {};
    
          for (const [className, value] of Object.entries(data)) {
            if (value === true) {
              classList.push(className);
              divisionList[className] = [];
            } else if (typeof value === 'object') {
              classList.push(className);
              divisionList[className] = Object.keys(value).filter(div => value[div]); // Get divisions that are true
            }
          }
          setClasses(classList);
          setDivisions(divisionList); 
        }
      } catch (error) {
        console.error("Error fetching classDiv data: ", error);
      }
    };

    // useEffect(() => {
    //   fetchClassDivData();
    //   if (divisions && Object.keys(divisions).length > 0) {
    //     const divisionsList = Object.values(divisions).flat();
    //     setDivisionOptions(divisionsList);
    //   }
    // }, [udiseNumber, divisions]);
    
    useEffect(() => {
      const fetchData = async () => {
        if (udiseNumber) {
          try {
            const data = await fetchClassDivData(udiseNumber);
            if (data) {
              const uniqueClasses = Array.from(new Set(data.map(item => item.currentClass))).filter(Boolean);
              const uniqueDivisions = Array.from(new Set(data.map(item => item.division))).filter(Boolean);
              setClassOptions(uniqueClasses);
              setDivisionOptions(uniqueDivisions);
              setClasses(uniqueClasses); // Set classes state
            } else {
              console.error('No data found');
            }
          } catch (error) {
            console.error('Error fetching data:', error);
          }
        }
      };
      fetchData();
    }, [udiseNumber]); // Ensure udiseNumber is the only dependency here
    
    useEffect(() => {
      if (selectedClass && selectedDivision) {
        fetchSubjects();
      }
    }, [selectedClass, selectedDivision]); // Only run when selectedClass or selectedDivision changes
      const handleClassChange = (event) => {
        const selected = event.target.value;
        setSelectedClass(selected);
      };

  


 // Fetch test names when a subject is selected
useEffect(() => {
  
  if (selectedClass && selectedDivision && subject) {
    fetchTestNames();
  }
}, [selectedClass, selectedDivision, subject]);

  const fetchSubjects = async () => {
    const db = getDatabase();
    const path = `schoolRegister/${udiseNumber}/Exam/`;
    const dbRef = ref(db, path);
  
    try {
      const snapshot = await get(dbRef);
      if (snapshot.exists()) {
        const data = snapshot.val();
        const filteredSubjects = new Set();
  
        // Extract subjects for selected class and division
        Object.keys(data).forEach((key) => {
          const [studentClass, studentDivision, subject] = key.split("&&");
  
          if (
            studentClass === selectedClass && // Use selectedClass
            studentDivision === selectedDivision // Use selectedDivision
          ) {
            filteredSubjects.add(subject);
          }
        });
  
        setSubjects([...filteredSubjects]); // Update subjects dropdown
       
      } else {
        setSubjects([]);
        
      }
    } catch (error) {
      console.error("Error fetching subjects:", error);
    }
  };

  const fetchTestNames = async () => {
    const path = `schoolRegister/${udiseNumber}/Exam/${selectedClass}&&${selectedDivision}&&${subject}/tests`;
    const dbRef = ref(db, path);

    try {
      const snapshot = await get(dbRef);
      if (snapshot.exists()) {
        const tests = snapshot.val();
        const testNameList = Object.keys(tests);
        setTestNames(testNameList); // Update dropdown options
      } else {
        setTestNames([]);
        setErrorMessage("No tests found for the selected subject.");
      }
    } catch (error) {
      console.error("Error fetching test names:", error);
      setErrorMessage("Failed to fetch test names. Please try again.");
    }
  };

  const calculatePercentage = (score, totalMarks) => {
    if (totalMarks === 0 || isNaN(score) || isNaN(totalMarks)) return "N/A";
    return ((score / totalMarks) * 100).toFixed(2) + "%";
  };

  const handleFetchResults = async () => {
    if (!selectedClass || !selectedDivision  || !subject || !testName) {
      alert("Please fill out all fields to fetch results.");
      return;
    }

    try {
      const resultsRef = ref(db, `schoolRegister/${udiseNumber}/Exam/studentResult/`);
      const snapshot = await get(resultsRef);


      if (snapshot.exists()) {
        const data = snapshot.val();
        const filteredResults = Object.entries(data).reduce(
          (acc, [key, value]) => {
            const [
              serialNo,
              studentName,
              rollNo,
              studentClass,
              studentDivision,
              studentSubject,
            ] = key.split("&&");

            if (
              studentClass === selectedClass &&
              studentDivision === selectedDivision &&
              studentSubject === subject
            ) {
              if (value[testName]) {
                acc[key] = {
                  serialNo,
                  studentName,
                  rollNo,
                  test: testName,
                  ...value[testName],
                };
              }
            }
            return acc;
          },
          {}
        );

        // Fetch totalmarks from the schoolRegister/${udiseNumber}/Exam node based on your structure
        const totalMarksPath = `schoolRegister/${udiseNumber}/Exam/${selectedClass}&&${selectedDivision}&&${subject}/tests/${testName}/totalmarks`;
        const totalMarksRef = ref(db, totalMarksPath);

        const totalMarksSnapshot = await get(totalMarksRef);
        let totalMarks = "-"; 

        if (totalMarksSnapshot.exists()) {
          totalMarks = totalMarksSnapshot.val();
        } else {
          console.warn("Total Marks not found in the database.");
        }

        // Add totalMarks to each result
        Object.keys(filteredResults).forEach((key) => {
          filteredResults[key].totalMarks = totalMarks;
        });

        if (Object.keys(filteredResults).length > 0) {
          setResults(filteredResults);
          setErrorMessage("");
        } else {
          setResults({});
          setErrorMessage("No results found for the provided details.");
        }
      } else {
        setResults({});
        setErrorMessage("No results found.");
      }
    } catch (error) {
      console.error("Error fetching results:", error);
      setErrorMessage("Failed to fetch results. Please try again.");
    }
  };

  const toggleTestDetails = (studentKey) => {
    setSelectedTestDetails(results[studentKey]);
  };

  const closeModal = () => {
    setSelectedTestDetails(null);
  };

  return ( 
    <div className="main-content-of-page">
  
      {/* Form Section */}
      <div
        style={{
          maxWidth: "500px",
          width: "100%",
          padding: "25px",
          backgroundColor: "#ffffff",
          borderRadius: "12px",
          boxShadow: "0 6px 18px rgba(0, 0, 0, 0.2)",
          overflow: "hidden",
          margin:'auto',  marginBottom: "30px",
        }}
      >
        <h2
          style={{
            textAlign: "center",
            marginBottom: "20px",
            fontSize: "24px",
            color: "#333",
            fontWeight: "600",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: "10px",
          }}
        >
          <FaTable /> {language === "English" ? "Student Results" : "विद्यार्थ्यांचे निकाल"}
        </h2>

        <form
          onSubmit={(e) => e.preventDefault()}
          style={{ display: "flex", flexDirection: "column", gap: "15px" }}
        >
          <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
            <FaChalkboardTeacher style={{ color: "#555" }} />
            <label
              htmlFor="className"
              style={{ fontWeight: "500", color: "#555" }}
            >
              {language === "English" ? "Class" : "वर्ग"}
            </label>
          </div>
          <select
      id="currentClass"
      value={selectedClass}
      onChange={handleClassChange}
    >
       <option value="">{language === "English" ? " Select Class " : "वर्ग निवडा "}</option>
{Array.isArray(classes) && sortClasses(classes.filter(cls => typeof cls === 'string' && cls.trim() !== ""), language).map((cls, index) => (
    <option key={index} value={cls}>{cls}</option>
))}
    </select>

          {/* Division Input */}
          <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
            <FaUser style={{ color: "#555" }} />
            <label
              htmlFor="division"
              style={{ fontWeight: "500", color: "#555" }}
            >
              {language === "English" ? "Division" : "तुकडी"}
            </label>
          </div>
          <select
  id="division"
  value={selectedDivision}
  onChange={handleDivisionChange}
>
  <option value="">{language === "English" ? " Select Division: " : "तुकडी निवडा "}</option>
  {divisions[selectedClass] && divisions[selectedClass].map((division, index) => (
    <option key={index} value={division}>{division}</option>
  ))}
</select>

          <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
            <FaBook style={{ color: "#555" }} />
            <label
              htmlFor="subject"
              style={{ fontWeight: "500", color: "#555" }}
            >
                {language === "English" ? "Subject" : "विषय"}
            </label>
          </div>
          <select
            id="subject"
            value={subject}
            onChange={(e) => setSubject(e.target.value)}
            style={{
              padding: "10px",
              borderRadius: "8px",
              border: "1px solid #ddd",
              fontSize: "14px",
            }}
          >
          <option value=" "> {language === "English" ? "select subject" : "विषय निवडा"}</option>
    {subjects.map((subject, index) => (
      <option key={index} value={subject}>
        {subject}
      </option>
    ))}
          </select>

          {/* Test Name Dropdown */}
          <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
            <FaListOl style={{ color: "#555" }} />
            <label
              htmlFor="testName"
              style={{ fontWeight: "500", color: "#555" }}
            >
              {language === "English" ? "Test Name" : "चाचणी नाव"}
            </label>
          </div>
          <select
            id="testName"
            value={testName}
            onChange={(e) => setTestName(e.target.value)}
            style={{
              padding: "10px",
              borderRadius: "8px",
              border: "1px solid #ddd",
              fontSize: "14px",
            }}
          >
          <option value=" ">{language === "English" ? "select Test Name" : "चाचणी नाव निवडा"}</option>

             {testNames.length > 0 ? (
      testNames.map((test) => (
        <option key={test} value={test}>
          {test}
        </option>
      ))
    ) : (
      <option value="">{language === "English" ? "No tests available" : "कोणत्याही चाचण्या उपलब्ध नाहीत"}</option>
    )}
          </select>
          {/* Fetch Results Button */}
          <button
            onClick={handleFetchResults}
            style={{
              backgroundColor: "#007BFF",
              color: "#fff",
              padding: "10px",
              borderRadius: "8px",
              border: "none",
              cursor: "pointer",
              fontWeight: "600", width:'200px',
              fontSize: "14px",
              transition: "all 0.3s ease",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "10px", margin:'auto'
            }}
            onMouseOver={(e) => (e.target.style.backgroundColor = "#0056b3")}
            onMouseOut={(e) => (e.target.style.backgroundColor = "#007BFF")}
          > {language === "English" ? "Display Results" : "निकाल दाखवा"}
            <FaSearch />
          </button>
        </form>
      </div>

      {/* Results Table Section */}
      {errorMessage && (
        <p style={{ textAlign: "center", color: "red", marginBottom: "20px" }}>
          {errorMessage}
        </p>
      )}

      {results && Object.keys(results).length > 0 && (
        <div
          style={{
            width: "100%",
            maxWidth: "800px",
            backgroundColor: "#ffffff",
            padding: "20px",
            borderRadius: "12px",
            boxShadow: "0 6px 18px rgba(0, 0, 0, 0.2)",
            overflowX: "auto", margin:'30px auto'
          }}
        >
          <h4
            style={{
              textAlign: "center",
              marginBottom: "20px",
              fontWeight: "600",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "10px",
            }}
          >
            {language === "English" ? "Student Results- testName" : "विद्यार्थ्यांचे निकाल- चाचणी नाव"}
          </h4>
          <table
            style={{
              width: "100%",
              borderCollapse: "collapse",
              marginBottom: "10px",
              textAlign: "center",
              backgroundColor: "#fdfdfd",
            }}
          >
            <thead>
              <tr style={{ backgroundColor: "#f1f1f1" }}>
                <th style={{ padding: "8px", border: "1px solid #ddd", textAlign: 'center', fontWeight:'bold' }}>
                 {language === "English" ? " Roll No " : "रोल नंबर"}
                </th>
                <th style={{ padding: "3px", border: "1px solid #ddd", textAlign: 'center', fontWeight:'bold' }}>
                  {language === "English" ? " Student Name" : "विद्यार्थ्याचे नाव"}
                </th>
                
                <th style={{ padding: "8px", border: "1px solid #ddd", textAlign: 'center', fontWeight:'bold' }}>
                   {language === "English" ? "Total Marks" : "एकूण गुण"}
                </th>
                <th style={{ padding: "8px", border: "1px solid #ddd", textAlign: 'center', fontWeight:'bold' }}>
                   {language === "English" ? "Score" : "गुण"}
                </th>
                <th style={{ padding: "8px", border: "1px solid #ddd", textAlign: 'center', fontWeight:'bold' }}>
                  {language === "English" ? " Percentage" : "टक्केवारी"}
                </th>
                <th style={{ padding: "8px", border: "1px solid #ddd", textAlign: 'center', fontWeight:'bold' }}>
                 {language === "English" ? "  Actions" : "कृती"}
                </th>
              </tr>
            </thead>

            <tbody>
              {Object.entries(results) .sort(([, a], [, b]) => a.rollNo - b.rollNo).map(([key, resultData]) => (
                <tr key={key}>
                <td style={{ padding: "8px", border: "1px solid #ddd", textAlign: 'center', }}>
                    {resultData.rollNo}
                  </td>
                  <td style={{ padding: "8px", border: "1px solid #ddd", textAlign: 'center', }}>
                    {resultData.studentName}
                  </td>
                
                  <td style={{ padding: "8px", border: "1px solid #ddd", textAlign: 'center', }}>
                    {resultData.totalMarks || "N/A"}
                  </td>
                  <td style={{ padding: "8px", border: "1px solid #ddd", textAlign: 'center', }}>
                    {resultData.score}
                  </td>
                  <td style={{ padding: "8px", border: "1px solid #ddd", textAlign: 'center', }}>
                    {calculatePercentage(
                      resultData.score,
                      resultData.totalMarks
                    )}
                  </td>
                  <td style={{ padding: "8px", border: "1px solid #ddd", textAlign: 'center', }}>
                    <button
                      onClick={() => toggleTestDetails(key)}
                      style={{
                        backgroundColor: "rgb(223 153 0)",
                        color: "#fff",
                        padding: "5px 8px",
                        borderRadius: "6px",
                        border: "none",
                        cursor: "pointer",
                        fontWeight: "500",
                        fontSize: "14px",
                        transition: "all 0.3s ease",
                      }}
                      onMouseOver={(e) =>
                        (e.target.style.backgroundColor = "rgb(239 177 43)")
                      }
                      onMouseOut={(e) =>
                        (e.target.style.backgroundColor = "rgb(223 153 0)")
                      }
                    >
                       {language === "English" ? " Show Test" : "चाचणी दाखवा"}
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {selectedTestDetails && (
        <div 
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              backgroundColor: "rgba(0, 0, 0, 0.5)", // Semi-transparent black background
              zIndex: 999,
            }}>
             <div
            style={{
              position: "fixed",
              top: "50%",
              left: "55%",
              transform: "translate(-50%, -50%)",
              background: "#fff",
              padding: "20px",
              borderRadius: "8px",
              boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
              zIndex: 1000,
              width: "80%",
              maxWidth: "800px",
              maxHeight: "80vh",
              overflowY: "auto",
            }}
          >
        <TestDetailsModal
          testDetails={selectedTestDetails}
          testName={testName}
          onClose={closeModal}
        />
        </div>
        </div>
      )}
    </div>
  );
};

export default StudentResult;
